'use client';
import React, { FC, useState, useRef } from 'react';

import { CampainBanner, Container } from '@shared';
import Carousel from '@components/Carousel/Carousel';
import { Separator } from '@components/formStyles';
import { SFMostPreferredHotelsViewModel } from '@api/models/SFMostPreferredHotelsViewModel';
import { PatchedLink } from '@utils/patched-link';
import Button from '@components/Button';
import { useBreakpoint } from '@contexts/breakpoints';

import PreferredHotelCard from './PreferredHotelCard';
import { TabButton, TabWrapper } from './styled';
import { SwiperSlider } from '../CampaignContent/styled';

const PreferredProduct: FC<{ data: SFMostPreferredHotelsViewModel }> = ({
  data,
}) => {
  const { xl } = useBreakpoint();
  const [activeTab, setActiveTab] = useState(data?.categories?.[0]?.text || '');
  const activeHref =
    data.categories?.find((cat) => cat.text === activeTab)?.link?.href || '';
  const carouselRef = useRef<{
    slideTo: (index: number, speed?: number) => void;
  }>(null);

  const handleTabChange = (tabText: string) => {
    setActiveTab(tabText);
    if (carouselRef.current) {
      carouselRef.current.slideTo(0, 300);
    }
  };

  const hotels = data?.hotels?.filter((item) => {
    return item?.categories?.[0]?.text === activeTab;
  });

  if (!data || !hotels) return null;
  return (
    <Container>
      <Separator />
      <CampainBanner title={data?.title ?? ''} href={activeHref} />

      {data.categories?.length > 0 && (
        <TabWrapper>
          <div style={{ width: '90%' }}>
            {data.categories.map((cat, i) => (
              <TabButton
                onClick={() => handleTabChange(cat?.text || '')}
                active={activeTab === cat.text}
                key={i}
              >
                {cat.text}
              </TabButton>
            ))}
          </div>
        </TabWrapper>
      )}
      <Carousel
        ref={carouselRef}
        loop={false}
        navigation={true}
        spaceBetween={0}
        slidesPerView='auto'
      >
        {hotels?.map((hotel, i) => (
          <SwiperSlider key={hotel.id || i}>
            <PreferredHotelCard hotel={hotel} index={i} />
          </SwiperSlider>
        ))}
      </Carousel>
      {activeHref && !xl ? (
        <>
          <Separator />
          <Button outline fullWidth>
            <PatchedLink href={activeHref} prefetch={false}>
              Tümünü Gör
            </PatchedLink>
          </Button>
        </>
      ) : null}
    </Container>
  );
};

export default PreferredProduct;
